"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getFileExtension: function() {
        return getFileExtension;
    },
    isFileSizeExceeded: function() {
        return isFileSizeExceeded;
    }
});
function getFileExtension(filename) {
    if (!filename || filename.indexOf('.') === -1) return '';
    const parts = filename.split('.');
    const lastPart = parts.pop();
    return lastPart ? `.${lastPart}` : '';
}
function isFileSizeExceeded(fileSize, maxSize = 1000 * 1000 * 10) {
    return fileSize > maxSize;
}

//# sourceMappingURL=file.js.map